/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from "@angular/common/http"

import { PrivacyRequestInterceptor } from "./privacy-request.interceptor"

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: PrivacyRequestInterceptor, multi: true },
]
